module.exports = __webpack_public_path__ + "static/media/bar2.86a16f6b.jpg";